import { RavenService } from './raven-service';
import { RavenInsertMeta } from '../../services/tracker/sentry';
export function ravenModule(bind) {
    return (moduleName) => {
        bind(RavenService).toConstantValue({
            track(action, others) {
                RavenInsertMeta(moduleName, action, others);
            },
        });
    };
}
